import { StateEditor } from "../StateEditor";
const handlers = {};
export function add(type, create) {
    handlers[type] = create;
}
export function get(type, ...argument) {
    const create = handlers[type];
    return create && create(argument);
}
export function format(data, type, ...argument) {
    const handler = get(type, ...argument);
    return handler
        ? handler.format(StateEditor.modify(handler.toString(typeof data == "string" ? parse(data, type, argument) : data)))
            .value
        : "";
}
export function parse(value, type, ...argument) {
    const handler = get(type, argument);
    return handler ? handler.fromString(handler.unformat(StateEditor.modify(value)).value) : undefined;
}
//# sourceMappingURL=base.js.map